export const HOME_RECENT_QUERIES_TASK_NAME = 'HomeRecentQueries';
